const AVAILABLE_LANGUAGES = ['en', 'fi', 'sv', 'et', 'es', 'ar', 'de', 'ru'] as const

export default AVAILABLE_LANGUAGES
